/**
 * RouteSeo — mounted once inside the router. On every navigation it resolves the
 * current path against the metadata registry and applies the head tags, so each
 * route gets its own title/description/canonical/robots/OG without editing the
 * page. Pages that own their <Seo> (FAQ, blog posts) are deferred to.
 */
import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import { resolveRouteMeta } from "./routeMeta";

const RouteSeo = () => {
  const { pathname } = useLocation();
  const seo = resolveRouteMeta(pathname);

  if (!seo) return null;
  return <Seo {...seo} />;
};

export default RouteSeo;
